import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { DeleteAccountModalComponent } from './delete-account-modal/delete-account-modal.component';
import { MyAccountApplicantComponent } from './my-account-applicant/my-account-applicant.component';
import { MyAccountManagerComponent } from './my-account-manager/my-account-manager.component';
import { PersonalDataModalComponent } from './personal-data-modal/personal-data-modal.component';

@NgModule({
  imports: [
    GCCoreModule
  ],
  declarations: [
    MyAccountApplicantComponent,
    MyAccountManagerComponent,
    PersonalDataModalComponent,
    DeleteAccountModalComponent
  ]
})
export class MyAccountModule { }
